import { BrowserRouter } from "react-router-dom";
import { AppShell } from "./AppShell";

const App = () => (
  <BrowserRouter>
    <AppShell />
  </BrowserRouter>
);

export default App;
